// src/main.js

import './scripts/about.js';
import './scripts/booking.js';
import './scripts/contact.js';
import './scripts/homepage.js';
import './scripts/service.js';
import './scripts/visa.js';
import { isValidEmail, isValidPhone } from './utils/validation.js';

// Wait for everything to load
document.addEventListener('DOMContentLoaded', () => {
  // Inject header/footer into every <div data-include="…">
  const includeEls = document.querySelectorAll('[data-include]');

  // Wait for all includes to finish, then re-attach mobile menu logic
  Promise.all(Array.from(includeEls).map(async (el) => {
    let path = el.getAttribute('data-include');
    if (!path.startsWith('/')) {
      path = `/${path}`; // Ensure path starts with root
    }
    try {
      const res = await fetch(path);
      if (!res.ok) throw new Error(`Could not fetch ${path}`);
      const html = await res.text();
      el.innerHTML = html;
    } catch (err) {
      console.error(`Error fetching ${path}:`, err);
      el.innerHTML = `<p style="color:red;">Error loading ${path}</p>`;
    }
  })).then(async () => {
    // Re-run mobile menu logic after includes are loaded
    initializeMobileMenu();

    // Add WhatsApp floating button to all pages
    addWhatsAppButton();

    // Run about page logic after includes are loaded
    if (window.location.pathname.endsWith('about.html') || window.location.pathname === '/about.html') {
      try {
        const aboutModule = await import('./scripts/about.js');
        if (aboutModule && typeof aboutModule.initAboutPage === 'function') {
          console.log('About page detected, initializing...');
          aboutModule.initAboutPage();
        }
      } catch (error) {
        console.error('Error loading about page script:', error);
      }
    }
  });

  // Dropdown submenu toggle (for "Services" on mobile)
  const dropdownLinks = document.querySelectorAll('.dropdown > a');
  dropdownLinks.forEach((link) =>
    link.addEventListener('click', (e) => {
      e.preventDefault(); // prevent "#" navigation
      const parentLi = link.parentElement;
      parentLi?.classList.toggle('active');
    })
  );

  // Click outside nav to close mobile menu/dropdowns
  document.addEventListener('click', (e) => {
    const nav = document.querySelector('.main-nav');
    const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
    const isInsideNav = e.composedPath().some((el) => el === nav || el === mobileMenuToggle);
    if (!isInsideNav) {
      nav?.classList.remove('open');
      nav?.classList.remove('active');
      mobileMenuToggle?.classList.remove('active');
      document.body.style.overflow = '';
      document.querySelectorAll('.dropdown.active').forEach((li) => {
        li.classList.remove('active');
      });
    }
  });
});

// Define mobile menu initialization function
function initializeMobileMenu() {
  const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
  const mainNav = document.querySelector('.main-nav');
  
  if (!mobileMenuToggle || !mainNav) {
    console.warn('Mobile menu elements not found');
    return;
  }

  // Remove any existing event listeners to prevent duplicates
  const newToggle = mobileMenuToggle.cloneNode(true);
  mobileMenuToggle.parentNode.replaceChild(newToggle, mobileMenuToggle);

  newToggle.addEventListener('click', (e) => {
    e.stopPropagation();
    mainNav.classList.toggle('active');
    newToggle.classList.toggle('active');
    document.body.style.overflow = mainNav.classList.contains('active') ? 'hidden' : '';
  });

  // Close menu when clicking nav links
  mainNav.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => {
      mainNav.classList.remove('active');
      newToggle.classList.remove('active');
      document.body.style.overflow = '';
    });
  });

  // Close menu when clicking outside
  document.addEventListener('click', (e) => {
    if (mainNav.classList.contains('active')) {
      const isClickInside = mainNav.contains(e.target) || newToggle.contains(e.target);
      if (!isClickInside) {
        mainNav.classList.remove('active');
        document.body.style.overflow = '';
      }
    }
  });
}

// Function to add WhatsApp floating button
function addWhatsAppButton() {
  // Check if WhatsApp button already exists to prevent duplicates
  if (document.querySelector('.whatsapp-float')) {
    return;
  }

  // Create WhatsApp button HTML
  const whatsappButton = document.createElement('div');
  whatsappButton.className = 'whatsapp-float';
  whatsappButton.innerHTML = `
    <a href="https://wa.me/923366283300" 
       target="_blank" 
       rel="noopener noreferrer" 
       class="whatsapp-btn"
       title="Chat with us on WhatsApp">
      <i class="fab fa-whatsapp"></i>
    </a>
  `;

  // Add to body
  document.body.appendChild(whatsappButton);
}

// Legacy function for backward compatibility
function mobileMenuToggle() {
  initializeMobileMenu();
}

// Initialize mobile menu immediately
initializeMobileMenu();
